(()=>{
document.documentElement.classList.remove('no-js');

const $ = (selector, scope = document) => scope.querySelector(selector);
const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

function showToast(message = 'Added to your cart.') {
  const toast = $('#WaterMateToast');
  if (!toast) return;
  const messageNode = $('[data-toast-message]', toast);
  if (messageNode) messageNode.textContent = message;
  toast.hidden = false;
  clearTimeout(window.waterMateToastTimer);
  window.waterMateToastTimer = setTimeout(() => { toast.hidden = true; }, 4200);
}

async function refreshCartCount() {
  const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
  if (!response.ok) return;
  const cart = await response.json();
  $$('[data-cart-count]').forEach((node) => {
    node.textContent = cart.item_count;
    node.closest('.cart-link')?.setAttribute('aria-label', `Cart with ${cart.item_count} items`);
  });
  return cart;
}

async function ajaxAdd(form) {
  if (form.dataset.pending === 'true') return;
  form.dataset.pending = 'true';
  const button = $('[type="submit"]', form);
  const original = button?.textContent;
  if (button) { button.disabled = true; button.textContent = 'Adding…'; }
  try {
    const endpoint = form.action.replace(/\/cart\/add(?:\.js)?$/, '/cart/add.js');
    const response = await fetch(endpoint, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item.');
    const cart = await refreshCartCount().catch(() => null);
    if ($('#WaterMateCart')) {
      openQuickCart();
      if (cart) renderQuickCart(cart); else loadQuickCart();
    }
    if (button) button.textContent = 'Added ✓';
    if (!$('#WaterMateCart')?.open) showToast(form.dataset.successMessage || window.WaterMate?.strings?.added);
    setTimeout(() => { if (button) { button.disabled = false; button.textContent = original; } }, 1700);
  } catch (error) {
    if (button) { button.disabled = false; button.textContent = original; }
    showToast(error.message || 'Please try again.');
  } finally {
    delete form.dataset.pending;
  }
}

document.addEventListener('submit', (event) => {
  const form = event.target.closest('.js-product-form');
  if (!form) return;
  event.preventDefault();
  ajaxAdd(form);
});

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const nav = document.getElementById(toggle.getAttribute('aria-controls'));
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    nav?.classList.toggle('is-open', !open);
  }

  const thumb = event.target.closest('[data-gallery-thumb]');
  if (thumb) {
    const gallery = thumb.closest('[data-gallery]');
    const main = $('[data-gallery-main]', gallery);
    if (main) {
      main.src = thumb.dataset.src;
      main.srcset = thumb.dataset.srcset || '';
      main.alt = thumb.dataset.alt || '';
      $$('[data-gallery-thumb]', gallery).forEach((item) => item.setAttribute('aria-current', String(item === thumb)));
    }
  }

  const choice = event.target.closest('[data-finder-choice]');
  if (choice) {
    const finder = choice.closest('[data-flavour-finder]');
    const group = choice.dataset.finderGroup;
    $$(`[data-finder-group="${group}"]`, finder).forEach((item) => item.setAttribute('aria-pressed', String(item === choice)));
    finder.dataset[group] = choice.dataset.finderChoice;
    updateFinder(finder);
  }
});

function updateFinder(finder) {
  const flavour = finder.dataset.flavour || 'mint';
  const context = finder.dataset.context || 'still';
  const profile = $(`[data-finder-profile="${flavour}"]`, finder);
  const result = $('[data-finder-result]', finder);
  if (!profile || !result) return;
  result.style.setProperty('--profile', profile.dataset.colour);
  const image = $('img', result);
  if (image) { image.src = profile.dataset.image; image.alt = profile.dataset.title; }
  $('[data-finder-title]', result).textContent = profile.dataset.title;
  $('[data-finder-copy]', result).textContent = profile.dataset[context] || profile.dataset.copy;
  const link = $('[data-finder-link]', result);
  if (link) link.href = profile.dataset.url;
  const input = $('input[name="id"]', result);
  const add = $('[type="submit"]', result);
  if (input) input.value = profile.dataset.variant || '';
  if (add) add.disabled = !profile.dataset.variant || profile.dataset.available !== 'true';
}

function initFinders(scope=document) {
  $$('[data-flavour-finder]',scope).forEach(finder=>{$$('[data-finder-choice]',finder).forEach(button=>button.disabled=false);updateFinder(finder);});
}
initFinders();
document.addEventListener('shopify:section:load',event=>initFinders(event.target));

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (!reduceMotion) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => { if (entry.isIntersecting) entry.target.classList.add('is-visible'); });
  }, { threshold: .12 });
  $$('.reveal').forEach((node) => observer.observe(node));

  $$('[data-tilt]').forEach((node) => {
    node.addEventListener('pointermove', (event) => {
      const rect = node.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - .5;
      const y = (event.clientY - rect.top) / rect.height - .5;
      node.style.setProperty('--ry', `${x * 7}deg`);
      node.style.setProperty('--rx', `${y * -7}deg`);
    });
    node.addEventListener('pointerleave', () => { node.style.setProperty('--ry', '0deg'); node.style.setProperty('--rx', '0deg'); });
  });

  const hero = $('[data-hero-visual]');
  hero?.addEventListener('pointermove', (event) => {
    const rect = hero.getBoundingClientRect();
    hero.style.setProperty('--hero-x', `${((event.clientX - rect.left) / rect.width - .5) * -9}px`);
    hero.style.setProperty('--hero-y', `${((event.clientY - rect.top) / rect.height - .5) * -7}px`);
  });
}

if ($('.sticky-buy')) document.body.classList.add('has-sticky-buy');

function closeMenu() {
  const toggle = $('[data-menu-toggle]');
  if (!toggle) return;
  toggle.setAttribute('aria-expanded', 'false');
  document.getElementById(toggle.getAttribute('aria-controls'))?.classList.remove('is-open');
}
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && $('[data-menu-toggle][aria-expanded="true"]')) {
    closeMenu();
    $('[data-menu-toggle]')?.focus();
  }
});
document.addEventListener('click', (event) => {
  if (event.target.closest('.site-nav a') || !event.target.closest('.site-header')) closeMenu();
});
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-variant-select]')) return;
  const select = event.target;
  const option = select.selectedOptions[0];
  const section = select.closest('[data-product-section]');
  const sticky = $('.sticky-buy');
  const available = option.dataset.available === 'true';
  $('[data-product-price]', section).textContent = option.dataset.price;
  if (sticky) {
    $('.sticky-buy-price', sticky).textContent = option.dataset.price;
    $('input[name="id"]', sticky).value = select.value;
  }
  [$('.product-form [type="submit"]', section), sticky && $('[type="submit"]', sticky)].filter(Boolean).forEach((button) => {
    button.disabled = !available;
    button.textContent = available ? 'Add to cart' : 'Sold out';
  });
  const image = $('[data-gallery-main]', section);
  if (image && option.dataset.image && section.dataset.newPackaging !== 'true') { image.src = option.dataset.image; image.srcset = ''; }
  const url = new URL(window.location.href);
  url.searchParams.set('variant', select.value);
  window.history.replaceState({}, '', url);
});
$$('[data-product-section] input[name="quantity"]').forEach((input) => {
  input.addEventListener('input', () => {
    const stickyQuantity = $('.sticky-buy input[name="quantity"]');
    if (stickyQuantity) stickyQuantity.value = input.value;
  });
});

const cartStrings = window.WaterMate?.strings || {};
let cartMutationPending = false;
function cartMoney(cents, currency) {
  return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style:'currency',currency:currency || window.WaterMate?.currency || 'CAD'}).format(cents / 100);
}
function openQuickCart() {
  const dialog = $('#WaterMateCart');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  if (!dialog.open) dialog.showModal();
  document.body.classList.add('cart-open');
}
function renderQuickCart(cart) {
  const dialog = $('#WaterMateCart');
  if (!dialog) return;
  const items = $('[data-drawer-items]',dialog);
  items.replaceChildren();
  cart.items.forEach((item) => {
    const row=document.createElement('article');row.className='wm-cart-line';
    const handle = item.handle || item.url?.split('/products/')[1]?.split(/[?#/]/)[0];
    const packaging = window.WaterMate?.packaging;
    const source = packaging?.[handle] || item.image;
    const isSet = packaging && ['the-complete-watermate-collection','watermate-collection'].includes(handle);
    if (isSet) {
      const set = document.createElement('div');set.className='wm-cart-set';
      Object.entries(packaging).forEach(([flavour,src])=>{const image=document.createElement('img');image.src=src;image.alt=flavour.replace('watermate-','').replaceAll('-',' ');image.width=35;image.height=52;set.append(image);});
      row.append(set);
    } else if (source) {const image=document.createElement('img');image.src=source;image.alt=item.product_title || item.title;image.width=80;image.height=120;row.append(image);}
    const info=document.createElement('div');info.className='wm-cart-line-info';
    const link=document.createElement('a');link.href=item.url;link.textContent=item.product_title || item.title;info.append(link);
    if (item.variant_title && item.variant_title !== 'Default Title') {const option=document.createElement('p');option.textContent=item.variant_title;info.append(option);}
    const price=document.createElement('strong');price.textContent=cartMoney(item.final_line_price,cart.currency);info.append(price);
    const controls=document.createElement('div');controls.className='wm-cart-line-controls';
    const label=document.createElement('label');label.textContent=cartStrings.quantity;
    const quantity=document.createElement('input');quantity.type='number';quantity.min='0';quantity.step='1';quantity.value=item.quantity;quantity.dataset.cartKey=item.key;quantity.setAttribute('aria-label',`${cartStrings.quantity}: ${item.product_title || item.title}`);quantity.inputMode='numeric';const stepper=document.createElement('span');stepper.className='wm-cart-stepper';
    [-1,1].forEach(direction=>{const step=document.createElement('button');step.type='button';step.dataset.cartStep=String(direction);step.dataset.cartKey=item.key;step.dataset.currentQuantity=item.quantity;step.textContent=direction===1?'+':'−';step.setAttribute('aria-label',`${direction===1?cartStrings.increase:cartStrings.decrease}: ${item.product_title || item.title}`);stepper.append(step);});
    stepper.insertBefore(quantity,stepper.lastChild);label.append(stepper);controls.append(label);
    const remove=document.createElement('button');remove.type='button';remove.textContent=cartStrings.remove;remove.dataset.cartRemove=item.key;remove.setAttribute('aria-label',`${cartStrings.remove}: ${item.product_title || item.title}`);controls.append(remove);
    info.append(controls);row.append(info);items.append(row);
  });
  $('[data-drawer-empty]',dialog).hidden=cart.item_count !== 0;
  $('[data-drawer-footer]',dialog).hidden=cart.item_count === 0;
  $('[data-drawer-total]',dialog).textContent=cartMoney(cart.total_price,cart.currency);
  $('[data-drawer-status]',dialog).textContent='';
  dialog.removeAttribute('aria-busy');
}
async function loadQuickCart() {
  const dialog=$('#WaterMateCart');if(!dialog)return;
  $('[data-drawer-status]',dialog).textContent=cartStrings.loading;
  dialog.setAttribute('aria-busy','true');
  try {const cart=await refreshCartCount();if(!cart)throw new Error();renderQuickCart(cart);}
  catch {dialog.removeAttribute('aria-busy');$('[data-drawer-status]',dialog).textContent=cartStrings.error;}
}
async function updateQuickCart(key, quantity, focusStep = null) {
  const dialog=$('#WaterMateCart');if(!dialog || cartMutationPending)return;
  cartMutationPending=true;dialog.setAttribute('aria-busy','true');
  $$('input,button', $('[data-drawer-items]',dialog)).forEach(node=>node.disabled=true);
  try {
    const response=await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})});
    const data=await response.json();if(!response.ok)throw new Error(data.description || data.message || cartStrings.error);
    renderQuickCart(data);
    $$('[data-cart-count]').forEach(node=>{node.textContent=data.item_count;node.closest('.cart-link')?.setAttribute('aria-label',`Cart with ${data.item_count} items`);});
    $$('input,button', $('[data-drawer-items]',dialog)).forEach(node=>node.disabled=false);
    const matches=$$('[data-cart-key]',dialog).filter(node=>node.dataset.cartKey===key);
    const next=matches.find(node=>focusStep===null?node.tagName==='INPUT':node.dataset.cartStep===focusStep) || $('[data-cart-key]',dialog) || $('[data-drawer-empty] a',dialog);next?.focus();
  } catch(error) {$('[data-drawer-status]',dialog).textContent=error.message || cartStrings.error;dialog.removeAttribute('aria-busy');$$('input[data-cart-key]',dialog).forEach(input=>{const step=$('[data-cart-step]',input.closest('.wm-cart-line-controls'));if(step)input.value=step.dataset.currentQuantity;});}
  finally {cartMutationPending=false;$$('input,button', $('[data-drawer-items]',dialog)).forEach(node=>node.disabled=false);}
}
document.addEventListener('click',event=>{
  const link=event.target.closest('.cart-link');
  const dialog=$('#WaterMateCart');
  if(link && dialog && typeof dialog.showModal==='function' && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey){event.preventDefault();openQuickCart();loadQuickCart();}
  const step=event.target.closest('[data-cart-step]');if(step)updateQuickCart(step.dataset.cartKey,Math.max(0,Number(step.dataset.currentQuantity)+Number(step.dataset.cartStep)),step.dataset.cartStep);
  const remove=event.target.closest('[data-cart-remove]');if(remove)updateQuickCart(remove.dataset.cartRemove,0);
  if(event.target===dialog && dialog?.open){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom)dialog.close();}
});
document.addEventListener('change',event=>{
  const input=event.target.closest('input[data-cart-key]');if(!input)return;
  if(input.checkValidity())updateQuickCart(input.dataset.cartKey,Number(input.value));
});
$('#WaterMateCart')?.addEventListener('close',()=>document.body.classList.remove('cart-open'));

})();
